import GiftIcon from '@discover-ui/icons/gift.svg';
import { currencyFormat } from '@discover-lib/dataFormats';
import { cn } from '@discover-lib/utils';
import useBookingServiceFeeDisplay, {
  getBookingFeeLabel,
} from '@/components/analytics/featureFlags/bookingServiceFee';
import globalState from '@/lib/globalState';

export type PD6665WelcomeCreditBannerProps = {
  feeAmount: number;
  creditAmount: number;
  people: number;
  className?: string;
};

export default function PD6665WelcomeCreditBanner({
  feeAmount,
  creditAmount,
  people,
  className,
}: PD6665WelcomeCreditBannerProps) {
  const bookingServiceFeeDisplay = useBookingServiceFeeDisplay();
  const remainingFee = Math.max(0, feeAmount - creditAmount);
  const showPerDiner = bookingServiceFeeDisplay === 'v1' && people > 0;
  const originalFeeLabel = currencyFormat(
    showPerDiner ? feeAmount / people : feeAmount,
    '',
    globalState.siteConfig
  );
  const remainingFeeLabel = getBookingFeeLabel(
    bookingServiceFeeDisplay,
    currencyFormat(remainingFee, '', globalState.siteConfig),
    people > 0 ? currencyFormat(remainingFee / people, '', globalState.siteConfig) : undefined
  );

  return (
    <div
      data-attribute="welcome-credit-banner"
      className={cn(
        'flex items-center gap-2 overflow-hidden rounded-[4px] bg-ds-pink-100 p-0.5 text-[12px] leading-[20px] text-ds-pink-800',
        className
      )}>
      <span className="inline-flex shrink-0 items-center gap-1 rounded-[4px] bg-white px-xs py-0.5 font-semibold">
        <GiftIcon width={14} height={14} className="shrink-0 text-ds-pink-700" aria-hidden="true" />
        New diner credit
      </span>
      <p className="whitespace-nowrap font-semibold text-ds-pink-900">
        <span className="text-ds-pink-700 line-through decoration-ds-pink-700">
          {originalFeeLabel}
        </span>{' '}
        {remainingFeeLabel}
      </p>
    </div>
  );
}
